export const radius = {
  sm: 6,
  md: 10,
  lg: 16,
  xl: 22
};
